import * as React from "react";
import { ACCESS_TOKEN_SALES_KEY_NAME } from "@nju/scope";

export interface IDecodedToken {
  name: string;
  preferred_username: string;
}

export function useDecodedToken(): IDecodedToken | undefined {
  return React.useMemo(() => {
    return decodeToken(localStorage.getItem(ACCESS_TOKEN_SALES_KEY_NAME));
  }, []);
}

export function decodeToken(token: string | null | undefined) {
  if (!token) {
    return;
  }

  try {
    return JSON.parse(
      Buffer.from(token.split(".")[1], "base64").toString("utf8"),
    );
  } catch {
    return;
  }
}
